import React from 'react'
import QuoteHistoryList from './List'
import SubmitQuotePanel from './SubmitQuote'
import './style/index.scss'

const QuoteHistoryPanel = (props) => {
  return (
    <React.Fragment>
      <SubmitQuotePanel {...props} />
      <QuoteHistoryList />
    </React.Fragment>
  )
}

export default QuoteHistoryPanel
